import {useEffect} from 'react';
import {cookies, config, useLocation} from 'helpers';

export function Loading() {
  const location = useLocation();
  useEffect(() => {
    if (!cookies.get('token')) {
      if (config.development && window.location.pathname != '/login/') {
        window.location = '/login/';
      } else if (!config.development) {
        const redirect = encodeURIComponent(location.pathname);
        window.location = `https://${config.appHost}/login/?redirect=${redirect}`;
      }
    }
  }, []);
  return null;
}
